/* eslint-disable import/no-mutable-exports */
var monitorTopPanel = {
  init: function () {

  }    
};

export default monitorTopPanel;